/* Product page behaviour. Per-product values arrive in #spd-pdp-config. */
(function() {
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('spd-pdp-config').textContent) || {}; } catch (e) {}
  document.addEventListener('DOMContentLoaded', function () {

    // ---- Add gallery page indicator dots ----
    function pdpAddGalleryDots() {
      var gallery = document.querySelector('.gallery-wrapper');
      if (!gallery) return;
      if (gallery.querySelector('.pdp-gallery-dots')) return; // already added

      // Target ONLY actual thumbnail elements (try selectors in order of specificity)
      var thumbs = gallery.querySelectorAll('.gallery-navigation--scroller > *');
      if (!thumbs.length) thumbs = gallery.querySelectorAll('.product-gallery--navigation > a, .product-gallery--navigation > button, .product-gallery--navigation > li');
      if (!thumbs.length) thumbs = gallery.querySelectorAll('.product-gallery--thumb');
      if (!thumbs.length) thumbs = gallery.querySelectorAll('[data-thumb-index]');

      if (!thumbs || thumbs.length <= 1) return;

      var container = document.createElement('div');
      container.className = 'pdp-gallery-dots';
      // Pointer-only indicator; the arrows and thumbnails already carry this for AT.
      container.setAttribute('aria-hidden', 'true');

      Array.prototype.forEach.call(thumbs, function (thumb, idx) {
        var dot = document.createElement('span');
        dot.className = 'pdp-gallery-dot';
        if (idx === 0 || thumb.classList.contains('active') || thumb.classList.contains('is-active') || thumb.getAttribute('aria-current') === 'true') {
          dot.classList.add('active');
        }
        dot.addEventListener('click', function () {
          try { thumb.click(); } catch (e) {}
          setActiveDot(idx);
        });
        container.appendChild(dot);
      });

      gallery.appendChild(container);

      function setActiveDot(idx) {
        container.querySelectorAll('.pdp-gallery-dot').forEach(function (d) { d.classList.remove('active'); });
        if (container.children[idx]) container.children[idx].classList.add('active');
      }

      // Sync active dot by re-checking which thumbnail is currently marked active by the theme
      function syncActiveDot() {
        var activeIdx = -1;
        Array.prototype.forEach.call(thumbs, function (thumb, idx) {
          if (
            thumb.classList.contains('active') ||
            thumb.classList.contains('is-active') ||
            thumb.classList.contains('selected') ||
            thumb.classList.contains('current') ||
            thumb.getAttribute('aria-current') === 'true' ||
            thumb.getAttribute('aria-selected') === 'true' ||
            thumb.getAttribute('data-active') === 'true' ||
            thumb.getAttribute('data-selected') === 'true'
          ) {
            activeIdx = idx;
          }
        });
        if (activeIdx >= 0) setActiveDot(activeIdx);
      }

      // 1) Mutation observer on every thumbnail (catches class/aria changes)
      try {
        var thumbObs = new MutationObserver(syncActiveDot);
        Array.prototype.forEach.call(thumbs, function (thumb) {
          thumbObs.observe(thumb, { attributes: true, attributeFilter: ['class', 'aria-current', 'aria-selected', 'data-active', 'data-selected'] });
        });
      } catch (e) {}

      // 2) Mutation observer on the main viewer (catches image swaps, src changes, etc.)
      try {
        var viewer = gallery.querySelector('.product-gallery--viewer');
        if (viewer) {
          var viewerObs = new MutationObserver(function () {
            setTimeout(syncActiveDot, 60);
          });
          viewerObs.observe(viewer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'src', 'style', 'aria-hidden'] });
        }
      } catch (e) {}

      // 3) Click listener on the entire gallery — identify which thumb was clicked AND re-sync via class check
      gallery.addEventListener('click', function (e) {
        // Direct identification: walk through thumbs and find the one containing the click target
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i] === e.target || thumbs[i].contains(e.target)) {
            setActiveDot(i);
            break;
          }
        }
        // Also re-sync via class check after a delay (in case the theme updates classes asynchronously)
        setTimeout(syncActiveDot, 80);
        setTimeout(syncActiveDot, 300);
      });

      // 3b) Direct click listener on each thumbnail (catches the click before any event.stopPropagation())
      Array.prototype.forEach.call(thumbs, function (thumb, idx) {
        thumb.addEventListener('click', function () {
          setActiveDot(idx);
        }, true); // capture phase so we run even if the theme stops propagation
      });

      // 4) Polling fallback (every 800ms) — cheap insurance against any update path we haven't accounted for
      setInterval(syncActiveDot, 800);

      // 5) Scroll & IntersectionObserver detection — catches mobile swipe gestures
      try {
        var viewer = gallery.querySelector('.product-gallery--viewer');
        if (viewer) {
          // Find slides — try several selectors, must match thumb count to be reliable
          var slides = viewer.children;
          if (slides.length !== thumbs.length) {
            slides = viewer.querySelectorAll('img');
          }
          if (slides.length !== thumbs.length) {
            slides = viewer.querySelectorAll('.gallery-image, [data-image-id]');
          }

          if (slides.length === thumbs.length) {
            // IntersectionObserver: when a slide intersects the viewer at >50%, mark its dot active
            var slideObs = new IntersectionObserver(function (entries) {
              var best = null;
              entries.forEach(function (en) {
                if (!best || en.intersectionRatio > best.intersectionRatio) best = en;
              });
              if (best && best.intersectionRatio >= 0.5) {
                var idx = Array.prototype.indexOf.call(slides, best.target);
                if (idx >= 0) setActiveDot(idx);
              }
            }, { root: viewer, threshold: [0.5, 0.75, 1.0] });
            Array.prototype.forEach.call(slides, function (s) { slideObs.observe(s); });
          }

          // Scroll listener — finds the slide whose center is closest to the viewer's center
          var scrollTimer;
          var onScroll = function () {
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(function () {
              var slidesNow = viewer.children;
              if (slidesNow.length !== thumbs.length) {
                slidesNow = viewer.querySelectorAll('img');
              }
              if (slidesNow.length !== thumbs.length) return;

              var vRect = viewer.getBoundingClientRect();
              var vCenter = vRect.left + vRect.width / 2;
              var closestIdx = -1, closestDist = Infinity;
              Array.prototype.forEach.call(slidesNow, function (slide, idx) {
                var r = slide.getBoundingClientRect();
                var c = r.left + r.width / 2;
                var d = Math.abs(vCenter - c);
                if (d < closestDist) { closestDist = d; closestIdx = idx; }
              });
              if (closestIdx >= 0) setActiveDot(closestIdx);
            }, 80);
          };
          viewer.addEventListener('scroll', onScroll, { passive: true });
          viewer.addEventListener('touchend', onScroll, { passive: true });
          // Also listen on possible inner scroll container
          var innerScroller = viewer.querySelector('.gallery-viewer--scroller, .swiper-wrapper, .flickity-slider, [data-scroller]');
          if (innerScroller) {
            innerScroller.addEventListener('scroll', onScroll, { passive: true });
            innerScroller.addEventListener('touchend', onScroll, { passive: true });
          }
        }
      } catch (e) { /* no-op */ }
    }

    pdpAddGalleryDots();
    setTimeout(pdpAddGalleryDots, 500);
    setTimeout(pdpAddGalleryDots, 1500);
    setTimeout(pdpAddGalleryDots, 3000);

    // ---- Add prev/next arrows over the main gallery image ----
    function pdpAddGalleryArrows() {
      var gallery = document.querySelector('.gallery-wrapper');
      if (!gallery) return;
      var viewer = gallery.querySelector('.product-gallery--viewer') || gallery.querySelector('.product-gallery');
      if (!viewer) return;
      if (viewer.querySelector('.pdp-gallery-arrow')) return; // already added

      var thumbs = gallery.querySelectorAll('.gallery-navigation--scroller > *');
      if (!thumbs.length) thumbs = gallery.querySelectorAll('.product-gallery--navigation > a, .product-gallery--navigation > button, .product-gallery--navigation > li');
      if (!thumbs.length) thumbs = gallery.querySelectorAll('.product-gallery--thumb');
      if (!thumbs || thumbs.length <= 1) return; // single-image products get no arrows

      function currentIndex() {
        // This theme marks the active thumbnail with data-gallery-selected="true"
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].getAttribute('data-gallery-selected') === 'true') return i;
        }
        // Fallbacks for other theme conventions
        for (var j = 0; j < thumbs.length; j++) {
          var t = thumbs[j];
          if (t.classList.contains('active') || t.classList.contains('is-active') || t.classList.contains('selected') || t.classList.contains('current') || t.getAttribute('aria-current') === 'true' || t.getAttribute('aria-selected') === 'true') return j;
        }
        return 0;
      }
      function go(delta) {
        var n = (currentIndex() + delta + thumbs.length) % thumbs.length;
        try { thumbs[n].click(); } catch (e) {}
      }
      function makeArrow(dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pdp-gallery-arrow pdp-gallery-arrow--' + (dir < 0 ? 'prev' : 'next');
        b.setAttribute('aria-label', dir < 0 ? 'Previous image' : 'Next image');
        b.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" d="' + (dir < 0 ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
        b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(dir); });
        return b;
      }

      if (getComputedStyle(viewer).position === 'static') viewer.style.position = 'relative';
      // Ahead of the slides, so the arrows come first in the tab order.
      viewer.insertBefore(makeArrow(1), viewer.firstChild);
      viewer.insertBefore(makeArrow(-1), viewer.firstChild);
    }

    pdpAddGalleryArrows();
    setTimeout(pdpAddGalleryArrows, 500);
    setTimeout(pdpAddGalleryArrows, 1500);
    setTimeout(pdpAddGalleryArrows, 3000);

    // ---- Rebuild Quantity + Currency UI from scratch using new clean wrappers ----
    function pdpRebuildQtyCurrency() {
      var atcWrap = document.querySelector('.atc-wrapper');
      if (!atcWrap) return;
      if (atcWrap.querySelector('.pdp-qty-currency-row')) return; // already done

      // Find ALL qty selects/inputs (there may be duplicates from the snippet)
      var qtyEls = Array.prototype.slice.call(atcWrap.querySelectorAll(
        '#product-quantity-select, #product-quantity-input, select[name="quantity"], input[name="quantity"]'
      ));
      var qtyEl = qtyEls[0] || null;

      var origCurrWrap = atcWrap.querySelector('.currency-selector-wrapper-pdp');
      var currEl = origCurrWrap ? origCurrWrap.querySelector('select') : null;

      if (!qtyEl && !currEl) return;

      // Find the original layout container so we can insert the new row in its place
      var origLayoutContainer = atcWrap.querySelector('.product-form--atc-qty');
      if (!origLayoutContainer && qtyEl) {
        origLayoutContainer = qtyEl.closest('fieldset') || qtyEl.closest('.form-field-select-wrapper');
      }

      // Build the new row
      var row = document.createElement('div');
      row.className = 'pdp-qty-currency-row';

      if (qtyEl) {
        // If quantity is an <input>, convert it to a <select> dropdown with
        // 1–9 + "10+" options, swapping to a number input when 10+ is picked
        // and back to a dropdown when the value drops below 10 or is cleared.
        if (qtyEl.tagName === 'INPUT') {
          var maxAttr = qtyEl.getAttribute('max') || qtyEl.getAttribute('data-max');
          var maxQty = parseInt(maxAttr, 10);
          if (!maxQty || maxQty < 1) maxQty = 9999;

          var minQty = parseInt(qtyEl.getAttribute('min'), 10);
          if (!minQty || minQty < 1) minQty = 1;

          var currentQty = parseInt(qtyEl.value, 10) || minQty;

          var qtyAttrs = {
            id: qtyEl.id || '',
            name: qtyEl.name || '',
            className: qtyEl.className || ''
          };
          // Capture data-* attributes too
          var qtyDataAttrs = {};
          Array.prototype.slice.call(qtyEl.attributes).forEach(function (a) {
            if (a.name.indexOf('data-') === 0 || a.name === 'aria-label') qtyDataAttrs[a.name] = a.value;
          });

          function pdpApplyAttrs(el) {
            if (qtyAttrs.id) el.id = qtyAttrs.id;
            if (qtyAttrs.name) el.name = qtyAttrs.name;
            if (qtyAttrs.className) el.className = qtyAttrs.className;
            for (var k in qtyDataAttrs) el.setAttribute(k, qtyDataAttrs[k]);
          }

          function pdpMakeQtySelect(currentVal) {
            var sel = document.createElement('select');
            pdpApplyAttrs(sel);

            for (var v = minQty; v <= Math.min(9, maxQty); v++) {
              var opt = document.createElement('option');
              opt.value = v;
              opt.textContent = v;
              if (v === currentVal) opt.selected = true;
              sel.appendChild(opt);
            }
            if (maxQty >= 10) {
              var optTen = document.createElement('option');
              optTen.value = '10';
              optTen.textContent = '10+';
              optTen.setAttribute('data-tenplus', '1');
              if (currentVal >= 10) optTen.selected = true;
              sel.appendChild(optTen);
            }

            sel.addEventListener('change', function () {
              var picked = sel.options[sel.selectedIndex];
              if (picked && picked.getAttribute('data-tenplus') === '1') {
                var input = pdpMakeQtyInput(10);
                sel.parentNode.replaceChild(input, sel);
                input.focus();
                input.select();
              }
            });
            return sel;
          }

          function pdpMakeQtyInput(currentVal) {
            var input = document.createElement('input');
            input.type = 'number';
            input.min = 1;
            input.max = maxQty;
            input.value = currentVal;
            pdpApplyAttrs(input);

            // When user finishes editing, if value < 10 or empty, swap back to dropdown
            function maybeRevert() {
              var v = parseInt(input.value, 10);
              if (!v || v < 10) {
                var newSel = pdpMakeQtySelect(v && v > 0 ? v : 1);
                input.parentNode.replaceChild(newSel, input);
                return newSel;
              }
              return null;
            }
            input.addEventListener('blur', maybeRevert);
            input.addEventListener('keydown', function (e) {
              if (e.key === 'Enter') {
                e.preventDefault();
                input.blur();
              } else if (e.key === 'Escape') {
                input.value = 1;
                var newSel = maybeRevert();
                if (newSel) { try { newSel.focus(); } catch (e2) {} }
              }
            });
            return input;
          }

          var newEl = (currentQty > 9) ? pdpMakeQtyInput(currentQty) : pdpMakeQtySelect(currentQty);
          qtyEl.parentNode.replaceChild(newEl, qtyEl);
          qtyEl = newEl;
        }

        var qtyField = document.createElement('div');
        qtyField.className = 'pdp-qty-field';
        var prefix = document.createElement('span');
        prefix.className = 'pdp-qty-prefix';
        prefix.textContent = 'Quantity : ';
        qtyField.appendChild(prefix);
        qtyField.appendChild(qtyEl); // moves first quantity element
        row.appendChild(qtyField);
      }

      if (currEl) {
        var currField = document.createElement('div');
        currField.className = 'pdp-currency-field';
        currField.appendChild(currEl);
        row.appendChild(currField);
      }

      // Insert row at original layout position (so SAS checkbox + ATC button stay below it)
      if (origLayoutContainer) {
        origLayoutContainer.parentNode.insertBefore(row, origLayoutContainer);
      } else {
        var atcBtn = atcWrap.querySelector('.product-form--atc-button, button[name="add"]');
        if (atcBtn) atcBtn.parentNode.insertBefore(row, atcBtn);
        else atcWrap.appendChild(row);
      }

      // Hide every qty/currency wrapper and any duplicate qty input that's NOT inside our new row
      function nukeIfOutsideRow(el) {
        if (!el || row.contains(el) || el.contains(row)) return;
        try { el.style.cssText = 'display:none!important;visibility:hidden!important;height:0!important;width:0!important;padding:0!important;margin:0!important;overflow:hidden!important;'; } catch (e) {}
      }

      // Hide any remaining duplicate qty selects/inputs (and their wrappers)
      atcWrap.querySelectorAll(
        '#product-quantity-select, #product-quantity-input, select[name="quantity"], input[name="quantity"]'
      ).forEach(function (el) {
        if (row.contains(el)) return;
        var w = el.closest('fieldset') || el.closest('.form-field-select-wrapper') || el.parentElement;
        nukeIfOutsideRow(w);
        nukeIfOutsideRow(el);
      });

      // Hide any leftover fieldsets/wrappers that no longer have functional content
      atcWrap.querySelectorAll('fieldset, .form-field-select-wrapper, .currency-selector-wrapper-pdp, .product-form--atc-qty').forEach(function (el) {
        if (row.contains(el) || el.contains(row)) return;
        // Only hide if it doesn't contain meaningful interactive content
        var hasFunctional = el.querySelector('button, textarea, input[type="checkbox"], input[type="radio"]:not([name^="options"]), input[type="text"], input[type="email"], input[type="tel"]');
        var hasOurStuff = el.querySelector('.pdp-qty-currency-row, .pdp-qty-field, .pdp-currency-field');
        if (!hasFunctional && !hasOurStuff) {
          nukeIfOutsideRow(el);
        }
      });
    }

    pdpRebuildQtyCurrency();
    setTimeout(pdpRebuildQtyCurrency, 300);
    setTimeout(pdpRebuildQtyCurrency, 1000);

    // ---- Wrap breadcrumb categories in a scrollable row, keep title pill separate ----
    function pdpRestructureBreadcrumbs() {
      try {
        var nav = document.querySelector('.breadcrumbs-container');
        if (!nav) return;
        // already restructured?
        if (nav.querySelector(':scope > .breadcrumbs-categories')) return;

        var current = nav.querySelector(':scope > .breadcrumbs-current');
        if (!current) {
          // snippets/breadcrumbs.liquid prints the product title as a plain last <span>
          var pills = nav.querySelectorAll(':scope > a, :scope > span:not(.breadcrumbs-delimiter):not(.breadcrumbs-tag)');
          current = pills.length ? pills[pills.length - 1] : null;
          if (current) current.classList.add('breadcrumbs-current');
        }
        if (!current) return; // no title pill, nothing to do

        var wrapper = document.createElement('div');
        wrapper.className = 'breadcrumbs-categories';

        // Move every child BEFORE .breadcrumbs-current into wrapper (skipping the chevron immediately preceding it)
        var node = nav.firstChild;
        while (node && node !== current) {
          var next = node.nextSibling;
          // skip the delimiter chevron immediately before the title pill — it's hidden anyway
          if (node.nodeType === 1 && node.classList && node.classList.contains('breadcrumbs-delimiter') && next === current) {
            node.parentNode.removeChild(node);
          } else {
            wrapper.appendChild(node);
          }
          node = next;
        }

        nav.insertBefore(wrapper, current);
      } catch (e) { /* no-op */ }
    }
    pdpRestructureBreadcrumbs();

    // ---- Custom dropdown for qty + currency selects (native <option> styling is too restricted) ----
    var pdpCddSeq = 0; // unique ids for each listbox + its options (aria-controls / aria-activedescendant)
    function pdpBuildCustomDropdown(selectEl) {
      if (!selectEl || selectEl.tagName !== 'SELECT') return;

      // If already enhanced, do not double-build.
      if (selectEl.dataset.pdpCdd === '1') return;
      selectEl.dataset.pdpCdd = '1';

      // Don't double-wrap if already inside a .pdp-cdd
      if (selectEl.parentNode && selectEl.parentNode.classList && selectEl.parentNode.classList.contains('pdp-cdd')) return;

      var wrapper = document.createElement('div');
      wrapper.className = 'pdp-cdd';

      if (selectEl.name === 'quantity' || selectEl.id === 'product-quantity-select') {
        wrapper.classList.add('pdp-cdd--qty');
      } else {
        wrapper.classList.add('pdp-cdd--currency');
      }

      selectEl.parentNode.insertBefore(wrapper, selectEl);
      wrapper.appendChild(selectEl);

      // Prevent native select dropdown from opening.
      selectEl.addEventListener('mousedown', function (e) { e.preventDefault(); }, true);
      selectEl.addEventListener('click', function (e) { e.preventDefault(); }, true);
      // The select stays in the DOM and the form (its value is what submits), but
      // the display below is the only tab stop and the only thing assistive tech sees.
      selectEl.setAttribute('tabindex', '-1');
      selectEl.setAttribute('aria-hidden', 'true');

      var display = document.createElement('div');
      display.className = 'pdp-cdd-display';
      display.tabIndex = 0;
      // Shopper Approved's product widget strips tabindex from these after load, which takes
      // the control out of the keyboard order. Put it back whenever it is removed.
      new MutationObserver(function () {
        if (!display.hasAttribute('tabindex')) display.tabIndex = 0;
      }).observe(display, { attributes: true, attributeFilter: ['tabindex'] });
      display.setAttribute('role', 'combobox');
      display.setAttribute('aria-haspopup', 'listbox');
      display.setAttribute('aria-expanded', 'false');
      // Mirror the native control's name, or fall back to what this wrapper is for.
      display.setAttribute('aria-label', selectEl.getAttribute('aria-label')
        || (wrapper.classList.contains('pdp-cdd--qty') ? 'Quantity' : 'Currency'));

      function refreshDisplay() {
        var i = selectEl.selectedIndex;
        display.textContent = (selectEl.options[i] && selectEl.options[i].text) || '';
      }

      refreshDisplay();

      // Insert the visible custom dropdown button.
      wrapper.appendChild(display);
      // The wrap runs async (MutationObserver), so the fresh select the Escape swap
      // focused is now hidden and aria-hidden. Hand the caret to the display.
      if (document.activeElement === selectEl) { try { display.focus(); } catch (e) {} }

      var menu = document.createElement('div');
      menu.className = 'pdp-cdd-menu';
      menu.id = 'pdp-cdd-menu-' + (++pdpCddSeq);
      menu.setAttribute('role', 'listbox');
      menu.hidden = true;
      menu.__pdpKeep = true;
      display.setAttribute('aria-controls', menu.id);

      // IMPORTANT: append to body so Shop Pay/Add to Cart cannot cover the menu.
      document.body.appendChild(menu);

      // Keyboard cursor while the list is open. The .selected class doubles as its visual.
      var hi = -1;
      function highlight(i) {
        var items = menu.children;
        if (!items.length) return;
        i = Math.max(0, Math.min(items.length - 1, i));
        Array.prototype.forEach.call(items, function (c, idx) {
          c.classList.toggle('selected', idx === i);
          c.setAttribute('aria-selected', idx === i ? 'true' : 'false');
        });
        hi = i;
        display.setAttribute('aria-activedescendant', items[i].id);
        if (items[i].scrollIntoView) items[i].scrollIntoView({ block: 'nearest' });
      }

      function rebuildMenu() {
        menu.innerHTML = '';

        Array.from(selectEl.options).forEach(function (opt, i) {
          var item = document.createElement('div');
          item.className = 'pdp-cdd-option';
          item.id = menu.id + '-opt-' + i;
          item.dataset.value = opt.value;
          item.dataset.index = i;
          if (opt.dataset && opt.dataset.tenplus) item.dataset.tenplus = opt.dataset.tenplus;
          item.textContent = opt.text;
          item.setAttribute('role', 'option');
          menu.appendChild(item);
        });
        highlight(selectEl.selectedIndex);
      }

      function positionMenu() {
        var rect = display.getBoundingClientRect();

        // Match the dropdown menu to the field width only.
        // This prevents the menu from stretching across the product card.
        var width = Math.round(rect.width);
        if (width < 110) width = 110;
        if (width > 180) width = 180;

        var left = Math.round(rect.left);
        var top = Math.round(rect.bottom + 8);

        // Keep inside viewport horizontally.
        if (left + width > window.innerWidth - 8) {
          left = Math.max(8, window.innerWidth - width - 8);
        }

        // Default is DOWN for both quantity and currency.
        // Only flip upward if there is not enough space below.
        var menuHeight = Math.min(menu.scrollHeight || 220, 220);
        if (top + menuHeight > window.innerHeight - 8) {
          var upTop = Math.round(rect.top - menuHeight - 8);
          if (upTop > 8) {
            top = upTop;
          }
        }

        menu.style.setProperty('--pdp-dropdown-width', width + 'px');
        menu.style.setProperty('--pdp-dropdown-left', left + 'px');
        menu.style.setProperty('--pdp-dropdown-top', top + 'px');

        menu.style.setProperty('width', width + 'px', 'important');
        menu.style.setProperty('min-width', width + 'px', 'important');
        menu.style.setProperty('max-width', width + 'px', 'important');
        menu.style.setProperty('left', left + 'px', 'important');
        menu.style.setProperty('top', top + 'px', 'important');
        menu.style.setProperty('right', 'auto', 'important');
        menu.style.setProperty('bottom', 'auto', 'important');
      }

      function closeMenu() {
        menu.hidden = true;
        display.setAttribute('aria-expanded', 'false');
        display.removeAttribute('aria-activedescendant');
        wrapper.classList.remove('pdp-cdd--open');
      }

      function closeAllMenus() {
        document.querySelectorAll('body > .pdp-cdd-menu').forEach(function (m) {
          m.hidden = true;
        });

        document.querySelectorAll('.pdp-cdd-display[aria-expanded="true"]').forEach(function (d) {
          d.setAttribute('aria-expanded', 'false');
        });

        document.querySelectorAll('.pdp-cdd--open').forEach(function (w) {
          w.classList.remove('pdp-cdd--open');
        });
      }

      function openMenu() {
        closeAllMenus();
        rebuildMenu();

        menu.hidden = false;
        display.setAttribute('aria-expanded', 'true');
        wrapper.classList.add('pdp-cdd--open');

        // Position after rendering.
        requestAnimationFrame(positionMenu);
      }

      display.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (menu.hidden) openMenu();
        else closeMenu();
      });

      // The currency select submits a form on change (page reload), so stepping it
      // with the list closed would navigate on every arrow press. Open the list instead.
      var stepOpensList = wrapper.classList.contains('pdp-cdd--currency');

      display.addEventListener('keydown', function (e) {
        var isOpen = !menu.hidden;
        var last = selectEl.options.length - 1;
        var cur = isOpen ? hi : selectEl.selectedIndex;
        var next = e.key === 'ArrowDown' ? Math.min(last, cur + 1)
          : e.key === 'ArrowUp' ? Math.max(0, cur - 1)
          : e.key === 'Home' ? 0
          : e.key === 'End' ? last : -1;
        if (next > -1) {
          e.preventDefault();
          if (isOpen) highlight(next);
          else if (stepOpensList) { openMenu(); highlight(next); }
          else if (next !== cur) pick(next); // closed: step the value like a native select
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (isOpen) pick(hi); else openMenu();
        } else if (e.key === 'Escape') {
          if (isOpen) { e.stopPropagation(); closeMenu(); }
        } else if (e.key === 'Tab' && isOpen) {
          pick(hi);
        }
      });

      menu.addEventListener('click', function (e) {
        var opt = e.target.closest('.pdp-cdd-option');
        if (!opt) return;

        e.preventDefault();
        e.stopPropagation();

        pick(parseInt(opt.dataset.index, 10));
      });

      function pick(idx) {
        selectEl.selectedIndex = idx;

        refreshDisplay();
        highlight(idx);

        closeMenu();

        // Dispatch change so the original theme logic still runs.
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));

        // If qty 10+ swaps select to input, remove custom wrapper cleanly.
        setTimeout(function () {
          if (!wrapper.parentNode) return;

          if (!wrapper.contains(selectEl)) {
            var replacement = null;
            Array.from(wrapper.children).forEach(function (child) {
              if (child !== display) replacement = child;
            });

            if (replacement) {
              wrapper.parentNode.replaceChild(replacement, wrapper);
              try {
                replacement.focus();
                if (replacement.select) replacement.select();
              } catch (e2) {}
            }

            if (menu && menu.parentNode) menu.parentNode.removeChild(menu);
          }
        }, 0);
      }

      // Keep menu aligned while page scrolls/resizes.
      window.addEventListener('scroll', function () {
        if (!menu.hidden) positionMenu();
      }, true);

      window.addEventListener('resize', function () {
        if (!menu.hidden) positionMenu();
      });

      // Sync display if select changes externally.
      selectEl.addEventListener('change', refreshDisplay);
    }

    function pdpEnhanceAllDropdowns() {
      try {
        // Keep portaled menus. They are controlled by their dropdown display.
        // Do not remove them during MutationObserver rebuilds, or the dropdown will appear empty/missing.
        document.querySelectorAll('body > .pdp-cdd-menu').forEach(function (menu) {
          if (!menu.__pdpKeep && menu.hidden) {
            menu.remove();
          }
        });

        // Quantity dropdown
        var qty = document.querySelector('.pdp-qty-field select');
        if (qty) pdpBuildCustomDropdown(qty);

        // Currency dropdown
        document.querySelectorAll('.pdp-currency-field select').forEach(pdpBuildCustomDropdown);
      } catch (e) { /* no-op */ }
    }

    pdpEnhanceAllDropdowns();
    setTimeout(pdpEnhanceAllDropdowns, 500);
    setTimeout(pdpEnhanceAllDropdowns, 1500);

    // Re-enhance whenever DOM changes (e.g. qty input → select swap on blur)
    var pdpCddDebounce;
    new MutationObserver(function () {
      clearTimeout(pdpCddDebounce);
      pdpCddDebounce = setTimeout(pdpEnhanceAllDropdowns, 50);
    }).observe(document.body, { childList: true, subtree: true });

    // Close menus on outside click
    document.addEventListener('click', function (e) {
      if (e.target.closest('.pdp-cdd') || e.target.closest('.pdp-cdd-menu')) return;

      document.querySelectorAll('body > .pdp-cdd-menu, .pdp-cdd-menu').forEach(function (m) {
        m.hidden = true;
      });

      document.querySelectorAll('.pdp-cdd-display[aria-expanded="true"]').forEach(function (d) {
        d.setAttribute('aria-expanded', 'false');
      });

      document.querySelectorAll('.pdp-cdd--open').forEach(function (w) {
        w.classList.remove('pdp-cdd--open');
      });
    });

    // ---- Disable snippet's variant selectors so they don't conflict with our buttons in the middle column ----
    try {
      document.querySelectorAll('.atc-wrapper select[name^="options"], .atc-wrapper input[name^="options"]:not(.pdp-option-input)').forEach(function (el) {
        el.disabled = true;
      });
    } catch (e) { /* no-op */ }

    // ---- Remove duplicate "I understand this is a SAS drive" checkboxes ----
    try {
      var sasLabels = Array.from(document.querySelectorAll('.atc-wrapper label')).filter(function (l) {
        return /sas drive/i.test(l.textContent || '');
      });
      sasLabels.slice(1).forEach(function (l) { l.remove(); });
    } catch (e) { /* no-op */ }

    // ---- Sync external variant radios with product form's hidden variant id ----
    // This fixes custom.js errors where addItemToCart tries to read `.value`
    // from a missing variant input/select.
    var formEl = document.getElementById(cfg.formId);
    if (!formEl) return;

    var productData = cfg.variants;
    var currentVariantId = cfg.currentVariantId;
    var optionInputs = Array.prototype.slice.call(
      document.querySelectorAll('.pdp-option-input')
    );

    function getOptionPositions() {
      var positions = [];

      optionInputs.forEach(function (input) {
        var position = parseInt(input.getAttribute('data-option-position'), 10);
        if (!isNaN(position) && positions.indexOf(position) === -1) {
          positions.push(position);
        }
      });

      positions.sort(function (a, b) { return a - b; });
      return positions;
    }

    /*
     * Keep later option groups dependent on the selections before them.
     * Example:
     *   Condition = New
     *   Storage Capacity then enables only capacities that exist for New.
     *
     * Earlier groups are intentionally not restricted by later selections,
     * so a customer can always change Condition and the later groups will
     * automatically move to the first valid value for that condition.
     */
    function refreshOptionAvailability() {
      if (!optionInputs.length) return;

      var positions = getOptionPositions();
      var selectedPreviousOptions = {};

      positions.forEach(function (position) {
        var positionIndex = position - 1;
        var groupInputs = optionInputs.filter(function (input) {
          return parseInt(input.getAttribute('data-option-position'), 10) === position;
        });

        groupInputs.forEach(function (input) {
          var valueIsAvailable = productData.some(function (variant) {
            if (!variant.available || !variant.options) return false;
            if (variant.options[positionIndex] !== input.value) return false;

            for (var previousIndex = 0; previousIndex < positionIndex; previousIndex++) {
              if (
                Object.prototype.hasOwnProperty.call(selectedPreviousOptions, previousIndex) &&
                variant.options[previousIndex] !== selectedPreviousOptions[previousIndex]
              ) {
                return false;
              }
            }

            return true;
          });

          input.disabled = !valueIsAvailable;
          input.setAttribute('aria-disabled', valueIsAvailable ? 'false' : 'true');
        });

        var selectedInput = groupInputs.find(function (input) {
          return input.checked && !input.disabled;
        });

        // The previous selection became invalid after an earlier option changed.
        // Clear it and select the first valid value in this group.
        if (!selectedInput) {
          groupInputs.forEach(function (input) {
            input.checked = false;
          });

          selectedInput = groupInputs.find(function (input) {
            return !input.disabled;
          });

          if (selectedInput) selectedInput.checked = true;
        }

        if (selectedInput) {
          selectedPreviousOptions[positionIndex] = selectedInput.value;
        }
      });
    }

    function normalizeVariantInput(variantId) {
      if (!variantId) variantId = currentVariantId;

      var variantFields = Array.prototype.slice.call(
        formEl.querySelectorAll('input[name="id"], select[name="id"]')
      );

      var primary = variantFields[0];

      if (!primary) {
        primary = document.createElement('input');
        primary.type = 'hidden';
        primary.name = 'id';
        primary.id = 'pdp-selected-variant-id';
        formEl.insertBefore(primary, formEl.firstChild);
        variantFields = [primary];
      }

      variantFields.forEach(function (field, index) {
        field.value = variantId;

        // Avoid duplicate id fields submitting different values.
        // Keep the first field enabled and sync/disable the rest.
        if (index > 0) {
          field.disabled = true;
          field.setAttribute('data-pdp-disabled-duplicate-id', 'true');
        }
      });

      return primary;
    }

    function getSelectedVariant() {
      if (!optionInputs.length) {
        return productData.find(function (variant) {
          return String(variant.id) === String(currentVariantId);
        }) || productData[0] || null;
      }

      var positions = getOptionPositions();
      var selectedValues = [];

      for (var index = 0; index < positions.length; index++) {
        var position = positions[index];
        var selectedInput = optionInputs.find(function (input) {
          return (
            parseInt(input.getAttribute('data-option-position'), 10) === position &&
            input.checked &&
            !input.disabled
          );
        });

        if (!selectedInput) return null;
        selectedValues.push(selectedInput.value);
      }

      return productData.find(function (variant) {
        if (!variant.options || variant.options.length < selectedValues.length) return false;

        return selectedValues.every(function (value, optionIndex) {
          return variant.options[optionIndex] === value;
        });
      }) || null;
    }

    function updateVariant(event) {
      refreshOptionAvailability();

      var variant = getSelectedVariant();
      var addButton = formEl.querySelector(
        'button[name="add"], .product-form--atc-button, [type="submit"]'
      );

      if (!variant) {
        if (addButton) addButton.disabled = true;
        return;
      }

      currentVariantId = variant.id;
      normalizeVariantInput(variant.id);

      // Only a shopper's option change rewrites the URL. A rewrite on load reads as a
      // second page_view to GA4 and the Ads tag.
      if (event && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }

      var priceEl = document.querySelector('.atc-wrapper .pdp-price-amount');
      if (priceEl) {
        priceEl.textContent = (variant.price / 100).toLocaleString('en-US', {
          style: 'currency',
          currency: cfg.currency
        });
      }

      if (addButton) {
        addButton.disabled = !variant.available;
      }

      syncOptionDropdowns();
    }

    /*
     * Mobile: mirror each option group into a native <select>.
     *
     * NOT the same job as the dropdowns in spd-pdp-options.js — those mirror the
     * metafield pill lists, whose <option> values are URLs to OTHER products, so
     * choosing one navigates. These groups are real Shopify variants, so the select
     * has to drive the radio that the variant engine already listens to.
     *
     * Rebuilt on every updateVariant so it tracks refreshOptionAvailability: values
     * that are unavailable for the current combination come through disabled, and a
     * value that got auto-reselected shows as selected here too. Visibility is pure
     * CSS (the pill row and the select swap at the breakpoint).
     */
    function syncOptionDropdowns() {
      var rows = document.querySelectorAll('.pdp-options-row');

      Array.prototype.forEach.call(rows, function (row) {
        var inputs = Array.prototype.slice.call(row.querySelectorAll('.pdp-option-input'));
        if (!inputs.length) return;

        var sel = row.previousElementSibling;
        if (!sel || !sel.classList || !sel.classList.contains('pdp-option-dd')) {
          sel = document.createElement('select');
          sel.className = 'opt-dd pdp-option-dd';
          sel.setAttribute('aria-label', row.getAttribute('aria-label') || 'Options');
          row.parentNode.insertBefore(sel, row);
          sel.addEventListener('change', function () {
            var match = null;
            Array.prototype.forEach.call(row.querySelectorAll('.pdp-option-input'), function (inp) {
              if (inp.value === sel.value) match = inp;
            });
            if (!match || match.disabled) return;
            match.checked = true;
            // hand off to the existing variant engine rather than duplicating it
            match.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        var markup = '';
        inputs.forEach(function (inp) {
          markup += '<option value="' + String(inp.value).replace(/"/g, '&quot;') + '"'
                 + (inp.disabled ? ' disabled' : '')
                 + (inp.checked ? ' selected' : '') + '>'
                 + String(inp.value).replace(/</g, '&lt;') + '</option>';
        });
        if (sel.innerHTML !== markup) sel.innerHTML = markup;
      });
    }

    // Create/sync the id field immediately for custom.js before any click.
    normalizeVariantInput(currentVariantId);

    optionInputs.forEach(function (input) {
      input.addEventListener('change', updateVariant);
    });

    updateVariant();

    // ---- JBOD: checkout-card Storage Capacity <select> forwards to the theme's variant engine ----
    // The real price/variant engine (custom.js) listens to the hidden native <select data-product-option>
    // that the product-options snippet renders. Our visible dropdown just forwards its value to that
    // native select and fires a change, so price, variant id, stock and URL all update through the
    // normal path — no duplicated logic. We also mirror the native select back onto ours so any
    // programmatic variant change (e.g. "first available" fallback) stays reflected in the UI.
    try {
      var jbodSelect = document.querySelector('[data-jbod-capacity-select]');
      // The dropdown's option is not always the first one (Drive Type / Storage Capacity), so the
      // native select is matched by option position, not taken in document order.
      var jbodPos0 = jbodSelect ? parseInt(jbodSelect.getAttribute('data-option-position'), 10) - 1 : 0;
      var optIndex = function (sel) { return parseInt(sel.getAttribute('data-product-option'), 10); };
      var nativeSels = Array.prototype.slice.call(document.querySelectorAll('[data-product-form] select[data-product-option], .atc-wrapper select[data-product-option]'));
      var nativeSel = nativeSels.filter(function (sel) { return optIndex(sel) === jbodPos0; })[0];
      if (jbodSelect && nativeSel) {
        // Map each capacity value -> availability, so we can toggle the sold-out notice on change.
        var soldoutMsg = document.querySelector('[data-jbod-soldout]');
        var availByValue = {};
        try {
          productData.forEach(function (v) { availByValue[v.options[jbodPos0]] = v.available; });
        } catch (e) { /* productData shape unexpected — leave the server-rendered state */ }
        function syncSoldout() {
          if (!soldoutMsg) return;
          // A capacity can exist under 2 drive types, so read the variant the selects point at first.
          var current = productData.filter(function (v) {
            return nativeSels.every(function (sel) { return v.options[optIndex(sel)] === sel.value; });
          })[0];
          var available = current ? current.available : availByValue[jbodSelect.value];
          soldoutMsg.hidden = available !== false;   // show only when explicitly unavailable
        }

        jbodSelect.addEventListener('change', function () {
          if (nativeSel.value !== jbodSelect.value) {
            // The other options have no visible control on JBOD pages. Keep them when that combination
            // exists, otherwise move them to a variant that carries this capacity.
            var withValue = productData.filter(function (v) { return v.options[jbodPos0] === jbodSelect.value; });
            var pick = withValue.filter(function (v) {
              return nativeSels.every(function (sel) { return optIndex(sel) === jbodPos0 || v.options[optIndex(sel)] === sel.value; });
            })[0] || withValue.filter(function (v) { return v.available; })[0] || withValue[0];
            if (pick) nativeSels.forEach(function (sel) { if (optIndex(sel) !== jbodPos0) sel.value = pick.options[optIndex(sel)]; });
            nativeSel.value = jbodSelect.value;
            nativeSel.dispatchEvent(new Event('change', { bubbles: true }));
          }
          syncSoldout();
        });
        nativeSel.addEventListener('change', function () {
          if (jbodSelect.value !== nativeSel.value) jbodSelect.value = nativeSel.value;  // programmatic set: no loop
          syncSoldout();
        });
        syncSoldout();
      }
    } catch (e) { /* leave the (hidden) native select + middle-column radios as the fallback selector */ }
  });
})();
